import React, { useState } from 'react';
import UstawieniaMagazynu from './UstawieniaMagazynu';
import RBACPanel from './ustawienia/RBACPanel';
import Guard from './auth/Guard';

export default function Ustawienia() {
  const [tab, setTab] = useState('magazyn');

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <button className={`add-button ${tab === 'magazyn' ? 'active' : ''}`} onClick={() => setTab('magazyn')}>
          Ustawienia magazynu
        </button>
        <Guard permission="users_permissions_manage">
          <button className={`add-button ${tab === 'rbac' ? 'active' : ''}`} onClick={() => setTab('rbac')}>
            RBAC
          </button>
        </Guard>
      </div>

      {tab === 'magazyn' && <UstawieniaMagazynu />}
      {tab === 'rbac' && (
        <Guard permission="users_permissions_manage" fallback={<p>Brak dostępu do konfiguracji RBAC.</p>}>
          <RBACPanel />
        </Guard>
      )}
    </div>
  );
}
